export var ActionStatus;
(function (ActionStatus) {
    ActionStatus["Closed"] = "closed";
    ActionStatus["Open"] = "open";
    ActionStatus["Pending"] = "pending";
})(ActionStatus || (ActionStatus = {}));
//# sourceMappingURL=action-status.js.map